'use client';
/* eslint-disable no-restricted-imports */
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import PlaylistGames from '~/client/components/Game/GameView/GameViewDesktop/shared/PlaylistGames';
import GameDescription from '~/client/components/Game/GameView/shared/GameDescription';
import CasinoBoost from '~/client/features/CasinoBoost';
import GameDetailsTable from '~/client/shared/game/GameDetailsTable';
import LazyLoad from '~/client/shared/LazyLoad';
import usePopover from '~/client/shared/NavBarControls/LoggedOutControls/hooks/usePopover';
import Popover from '~/client/shared/NavBarControls/LoggedOutControls/Popover';
import { CashierCurrencyType } from '~/schema/public';
import GameBlock from '@/server/components/Game/DesktopGameView/GameBlock';
import useGameCurrencySelect from '@/server/components/Game/GameCurrencySelect/useGameCurrencySelect';
import useChangeCurrencyNotification from '@/server/components/Game/MobileGameView/hooks/useChangeCurrencyNotification';
import useWalletCurrency from '@/server/components/Game/MobileGameView/hooks/useWalletCurrency';

type Props = {
  inGameCurrencyList: string[];
  inGameCurrency?: Unit;
  cashierCurrencyType?: CashierCurrencyType;
  cashierCurrency?: CashierCurrency;
  isLoggedIn: boolean;
  translations: Record<string, string>;
  isUbtcEnabled: boolean;
  rewardsNotification: RewardsNotification;
  isBitcasino?: boolean;
};

const GameViewModules: FC<Props> = ({
  rewardsNotification,
  inGameCurrencyList,
  inGameCurrency,
  cashierCurrencyType,
  cashierCurrency,
  translations,
  isUbtcEnabled,
}) => {
  const { popoverModule, handlePopoverClose } = usePopover();
  const { game } = useGameContext();
  const { walletCurrency } = useWalletCurrency(
    cashierCurrency,
    cashierCurrencyType,
  );
  const gameCurrencySelect = useGameCurrencySelect(
    isUbtcEnabled,
    inGameCurrencyList,
    inGameCurrency,
    walletCurrency,
  );
  useChangeCurrencyNotification(
    rewardsNotification,
    gameCurrencySelect.selectedCurrency,
    walletCurrency,
  );
  useChangeCurrencyNotification(rewardsNotification);
  return (
    <>
      {!!popoverModule && (
        <Popover module={popoverModule} onClose={handlePopoverClose} />
      )}
      <GameBlock
        translations={translations}
        gameCurrencySelect={gameCurrencySelect}
      />
      <CasinoBoost module="game" />
      <GameDetailsTable game={game} />
      <LazyLoad>
        <PlaylistGames />
      </LazyLoad>
      <GameDescription />
    </>
  );
};

export default GameViewModules;
